import { useContractStore } from "../store/contract";
import dateJs from "@/assets/js/date";
import { v4 as uuidv4 } from 'uuid';

const paymentSchedule = {
  /**
   * 预设
   */
  PaymentScheduleSettingEntity (entity) {
    return {
      id: entity.id,
      uniqueId: entity.uniqueId || uuidv4(),
      paymentSummaryId: entity.paymentSummaryId,
      description: entity.description || "",
      contractType: entity.contractType,
      contractAction: entity.contractAction,
      contractId: entity.contractId,
      campaignPeriodStart: entity.campaignPeriodStart,
      campaignPeriodEnd: entity.campaignPeriodEnd,
      noOfDays: entity.noOfDays,
      scheduleMediaAmount: entity.scheduleMediaAmount,
      scheduleProductionAmount: entity.scheduleProductionAmount,
      totalScheduleAmount: entity.totalScheduleAmount,
      psType: entity.psType,
      paymentTerm: entity.paymentTerm,
      invoiceTerm: entity.invoiceTerm,
      currency: entity.currency,
      contractDraftNo: entity.contractDraftNo,
      dates: [entity.campaignPeriodStart, entity.campaignPeriodEnd],
      psNo: entity.psNo,
    }
  },
  /**
   * Regenerate
   * @param {*} entity 
   * @returns 
   */
  PaymentScheduleEntity (entity) {
    const ps = PaymentScheduleModel(entity)

    ps.contractDraftNo = JSON.parse(ps.contractDraftNo)
    return ps
  },
  /**
   * 生成付款明细
   * @param {*} PaymentScheduleSetting 
   * @returns 
   */
  CreatePaymentDetailEntity (entity, PaymentScheduleSetting) {
    entity = entity || {}

    const PaymentScheduleDetail = PaymentScheduleDetailModel(entity);

    PaymentScheduleDetail.paymentUniqueId = PaymentScheduleSetting.uniqueId;
    PaymentScheduleDetail.paymentId = PaymentScheduleSetting.id
    PaymentScheduleDetail.periodNo = 1
    PaymentScheduleDetail.periodNoName = "1"
    PaymentScheduleDetail.paymentFrom = PaymentScheduleSetting.campaignPeriodStart
    PaymentScheduleDetail.paymentTo = PaymentScheduleSetting.campaignPeriodEnd
    PaymentScheduleDetail.noOfDays = PaymentScheduleSetting.noOfDays
    PaymentScheduleDetail.mediaInstallmentAmount = PaymentScheduleSetting.scheduleMediaAmount
    PaymentScheduleDetail.productionInstallmentAmount = PaymentScheduleSetting.scheduleProductionAmount
    PaymentScheduleDetail.totalAmount = parseFloat(PaymentScheduleSetting.scheduleMediaAmount) + parseFloat(PaymentScheduleSetting.scheduleProductionAmount)
    PaymentScheduleDetail.paymentDueDate = ConvertDateBySetting(PaymentScheduleSetting.paymentTerm, "payment", PaymentScheduleDetail)
    PaymentScheduleDetail.invoiceIssueDate = ConvertDateBySetting(PaymentScheduleSetting.invoiceTerm, "invoice", PaymentScheduleDetail)
    PaymentScheduleDetail.paymentStatus = "immediately"
    PaymentScheduleDetail.invoiceStatus = "notinvoiced"

    return PaymentScheduleDetail
  },
  /**
   * 保存付款摘要参数
   * @param {Object} entity 
   * @returns 
   */
  SavePaymentSummaryParam (entity) {
    return {
      id: entity.id,
      contractId: entity.contractId,
      campaignPeriodStart: entity.campaignPeriodStart,
      campaignPeriodEnd: entity.campaignPeriodEnd,
      noOfDays: entity.noOfDays,
      totalMediaAmount: entity.totalMediaAmount,
      totalProductionAmount: entity.totalProductionAmount,
      totalOutstandingMediaAmount: entity.totalOutstandingMediaAmount,
      totalOutstandingProductionAmount: entity.totalOutstandingProductionAmount,
      currency: entity.currency || "HKD"
    }
  },
  /**
   * 保存付款时间参数
   * @param {Object} entity 
   * @returns 
   */
  SavePaymentParam (entity) {
    const Param = PaymentScheduleModel(entity)
    Param.contractDraftNo = JSON.stringify(Param.contractDraftNo)
    Param.hasInvoice = Param.hasInvoice === "Y"
    return Param;
  }
}

/**
 * 设定转换为日期
 * @param {*} code 付款计划编码
 * @returns 
 */
const ConvertDateBySetting = (code, type, entity) => {
  code = code || ""

  const Settings = PaymentOptions(type)

  const Term = Settings.find(t => t.code === code) || null

  var dateStr = "";
  if (Term !== null) {
    if (Term.setting == "COD") {
      dateStr = dateJs.ConvertDateStr(new Date());
    }
    else if (Term.setting === "DUE") {
      const PaymentDueDate = entity.paymentDueDate
      dateStr = dateJs.ConvertDateStr(dateJs.AddDays(PaymentDueDate, Term.days));
    }
    else if (Term.setting == "Comm Start") {
      const PaymentFrom = entity.paymentFrom
      dateStr = dateJs.ConvertDateStr(dateJs.AddDays(PaymentFrom, Term.days));
    }
    else if (Term.setting == "Comm End") {
      const PaymentTo = entity.paymentTo
      dateStr = dateJs.ConvertDateStr(dateJs.AddDays(PaymentTo, Term.days));
    }
  }

  return dateStr;
}
/**
 * 设定转换为日期
 * @param {*} code 付款计划编码
 * @returns 
 */
const PaymentOptions = (code) => {
  const useContract = useContractStore();
  var PaymentOptions = []

  if (code === "payment") {
    PaymentOptions = useContract.PaymentTerms
  }

  if (code === "invoice") {
    PaymentOptions = useContract.InvoiceTerms
  }
  return PaymentOptions
}

// 付款时间实体
const PaymentScheduleModel = (entity) => {
  var contractDraftNo = entity.contractDraftNo || "[]"
  if (typeof (contractDraftNo) === "object") {
    contractDraftNo = JSON.stringify(contractDraftNo)
  }

  return {
    id: entity.id || 0,
    contractId: entity.contractId || 0,
    contractType: entity.contractType || "",
    contractAction: entity.contractAction || "",
    paymentSummaryId: entity.paymentSummaryId || 0,
    psSerialNo: entity.psSerialNo || 0,
    psNo: entity.psNo || "",
    contractDraftNo: contractDraftNo,
    campaignPeriodStart: entity.campaignPeriodStart || null,
    campaignPeriodEnd: entity.campaignPeriodEnd || null,
    noOfDays: entity.noOfDays || 0,
    noOfSchedule: entity.noOfSchedule || 1,
    scheduleMediaAmount: entity.scheduleMediaAmount || 0,
    scheduleProductionAmount: entity.scheduleProductionAmount || 0,
    totalScheduleAmount: entity.totalScheduleAmount || 0,
    psType: entity.psType || "",
    paymentTerm: entity.paymentTerm || "",
    invoiceTerm: entity.invoiceTerm || "",
    description: entity.description || "",
    hasInvoice: entity.hasInvoice || "",
    currency: entity.currency || "HKD",
    uniqueId: entity.uniqueId
  }
}

const PaymentScheduleDetailModel = (entity) => {
  return {
    id: entity.id || 0,
    uniqueId: entity.uniqueId || uuidv4(),
    paymentUniqueId: entity.paymentUniqueId || "",
    paymentId: entity.paymentId || 0,
    periodNo: entity.periodNo || 1,
    periodNoName: entity.periodNoName || "1",
    paymentFrom: entity.paymentFrom || null,
    paymentTo: entity.paymentTo || null,
    noOfDays: entity.noOfDays || 0,
    mediaInstallmentAmount: entity.mediaInstallmentAmount || 0,
    productionInstallmentAmount: entity.productionInstallmentAmount || 0,
    totalAmount: entity.totalAmount || 0,
    paymentDueDate: entity.paymentDueDate || null,
    invoiceIssueDate: entity.invoiceIssueDate || null,
    paymentStatus: entity.paymentStatus || "",
    invoiceStatus: entity.invoiceStatus || "",
    status: entity.status || "Active"
  }
}

export default paymentSchedule
